import { request } from "@/utils/request"

/**
 * 获取应用信息，当传递了应用ID时，查询指定ID的应用信息，当未指定ID时，查询当前登录用户所属的应用信息
 * @param { * } params
 * @returns 
 */
export function getAppInfo(params) {
  return request({
    url: '/appeditor/app/info',
    method: 'get',
    params
  })
}

/**
 * 获取当前用户可操作的应用列表
 * @param {*} params 
 * @returns 
 */
export function getAppListForCurrentUser(params) {
  return request({
    url: '/appeditor/app/list',
    method: 'get',
    params
  })
}

/**
 * 保存应用基本信息
 * @param {*} data 
 * @returns 
 */
export function saveApp(data) {
  return request({
    url: '/appeditor/app/save',
    method: 'post',
    data
  })
}

/**
 * 删除应用
 * @param {*} ids 应用ID列表
 * @returns 
 */
export function removeApps(ids) {
  return request({
    url: '/appeditor/app/remove',
    method: 'post',
    data: ids
  })
}

/**
 * 发布、取消发布应用
 * @param {*} data { id:应用ID， status: 1发布，2取消发布 }
 * @returns 
 */
export function releaseApp(data) {
  return request({
    url: '/appeditor/app/release',
    method: 'post',
    data
  })
}

/**
 * 拷贝应用
 * @param {*} data 
 * @returns 
 */
export function copyApp(data) {
  return request({
    url: '/appeditor/app/copy',
    method: 'post',
    data
  })
}
